<template>
    <div class="flex flex-col items-center text-center space-y-4">
      <p class="text-md text-gray-500">
        {{ data.coupon_code }} applied
      </p>
      <p class="text-xl font-semibold">
        You saved ₹{{ parseFloat(data.offer_value).toFixed(2) }} on your order
      </p>
      <button
        @click="closeComponent"
        class="px-5 py-2 text-lg text-orange-500 font-bold"
      >
        GOT IT
      </button>
    </div>
  </template>
  
<script setup>
import confetti from 'canvas-confetti';
const props = defineProps(['data']);
const emit = defineEmits(['close']);

const { gtag } = useGtag();
const auth = useAuth();
const isAuthenticated = auth && auth.access_token;
const userData = isAuthenticated
  ? {
      user_name: auth.user.first_name,
      user_phone: auth.user.phone,
      user_email: auth.user.email,
    }
  : {
      user_name: null,
      user_phone: null,
      user_email: null,
    };

function closeComponent() {
    emit('close');

    gtag('event', 'coupon_close_component', {
        action: 'Got_it_applied',
        coupon_code: props.data.coupon_code,
        ...userData,
    });
}

onMounted(() => {
    confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 }
    });
});


</script>


 
  

  
  